import { render } from "./WaterBillReceipt.vue?vue&type=template&id=c14ddb1c&scoped=true"
import script from "./WaterBillReceipt.vue?vue&type=script&lang=js"
export * from "./WaterBillReceipt.vue?vue&type=script&lang=js"

import "./WaterBillReceipt.vue?vue&type=style&index=0&id=c14ddb1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c14ddb1c"]])

export default __exports__